import { useFormContext } from 'react-hook-form';

import { FormField, FormItem, FormLabel, FormControl, FormDescription } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';

/**
 * Switch to seed demo store with products, payment flow, and checkout funnel
 */
export const CreateDemoProductsSwitch = () => {
  const { control } = useFormContext();
  return (
    <FormField
      control={control}
      name="createDemoProducts"
      render={({ field }) => (
        <FormItem className="flex flex-row items-start justify-between space-x-3 space-y-0 rounded-lg border p-4">
          <div className="space-y-0.5">
            <FormLabel className="text-base">Seed Demo Store</FormLabel>
            <FormDescription className="text-sm">
              Pre-configure your store with demo products, a sandbox payment flow, and a ready-to-use checkout funnel
            </FormDescription>
          </div>
          <FormControl>
            <Switch id="demo-seed-checkbox" checked={field.value} onCheckedChange={field.onChange} />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
